module.exports = __webpack_public_path__ + "img/ic_tools.053da1b9.svg";